export default function (state, action) {
  if (typeof state === 'undefined') {
    return {
      pageNumber: 0,
      summaries: [],
      totalSummariesCount: 0
    };
  }

  switch(action.type) {
    case 'LOAD SUMMARIES':
      return {
        ...state,
        ...{
          pageNumber: action.pageNumber,
          summaries: action.summaries,
          totalSummariesCount: action.totalSummariesCount
        }
      };
    case 'UNLOAD SUMMARIES':
      return { 
        ...state, 
        ...{
          summaries: []
        }
      };
  }
  
  return state;
}
